import React, {useState} from 'react';
import NoDataIndicator from "../NoDataIndicator";
import "../../saas/components/_react_switch.scss"
import {BsFillEyeFill} from "react-icons/bs"
import {Modal, ModalBody, ModalFooter, ModalHeader, Table} from "reactstrap";
import {Button} from "reactstrap";
import localized from "../../i18n";
import moment from "moment";
import Pagination from "../Pagination";

const AdminDashboardTableBody = (props) => {
    const {tableList, isLoadingData, handleUserStatus} = props;
    const [showDeleteModel, setShowDeleteModel] = useState(false);
    const [data,setData] = useState({});
    const [count, setPage] = useState(1);

    const toggleDeleteModel = (item =null) => {
        setShowDeleteModel(!showDeleteModel)
        setData(item)
    }
    if (tableList === [] && !isLoadingData) {
        return <NoDataIndicator/>
    }
    const start = (count - 1) * 10;
    const end =start + 10;
    const currentTodos = (data.purchase_history || []).slice(start, end);
    const totalPage = (Math.ceil((data.purchase_history || []).length / 10))
    return (
        <>
            {(tableList.data || []).map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{item.id}</td>
                        <td>{item.first_name || "-"}</td>
                        <td>{item.last_name || "-"}</td>
                        <td>{item.email || "-"}</td>
                        <td className="status_content">
                            <label className="switch">
                                <input type="checkbox" checked={item.status === 1} onChange={(e) => handleUserStatus(item ,e)}/>
                                <span className="slider round"/>
                            </label>
                        </td>
                        <td>
                            <div onClick={()=>toggleDeleteModel(item)}>
                                <BsFillEyeFill fontSize={25}/>
                            </div>
                        </td>
                    </tr>
                )
            })}
           <Modal isOpen={showDeleteModel} className="admin_dashboard_model">
               <ModalHeader>
                   <h3>User Information</h3>
               </ModalHeader>
               <ModalBody>
                   <div className="amount_payout">
                        <span className="price">
                            <span className="payout">Name : </span>
                            <span className="amount">{data.first_name + " " +data.last_name}</span>
                        </span>
                       <span className="price">
                            <span className="payout">Email : </span>
                            <span className="amount">{data.email}</span>
                        </span>
                       <span className="price">
                            <span className="payout">Used Credit : </span>
                            <span className="amount">{data.used_credit}</span>
                        </span>
                       <span className="price">
                            <span className="payout">Available Credit : </span>
                            <span className="amount">{data.available_credit}</span>
                        </span>
                   </div>
                   <h4>Payment History</h4>
                   <Table borderless={true} responsive={true}>
                       <thead>
                       <tr>
                           <th>{localized.No_of_credit}</th>
                           <th>{localized.credit_price}</th>
                           <th>{localized.credit_date}</th>
                       </tr>
                       </thead>
                       <tbody>
                       {(currentTodos || []).map((item, index) => {
                           return (
                               <tr key={index}>
                                    <th>{item.no_of_credit}</th>
                                    <th>{item.price} €</th>
                                    <th>{item.date ? moment(item.date).format("ll") : ""}</th>
                               </tr>
                           )
                       })}
                       </tbody>
                   </Table>

                   {(data.purchase_history || []).length !== 0 && (
                       <Pagination
                           page={count - 1}
                           pages={totalPage}
                           canPrevious={true}
                           canNext={count !== totalPage }
                           onPageChange={(page) => {
                               setPage(page + 1)
                           }}
                       />
                   )}

               </ModalBody>
               <ModalFooter>
                   <Button onClick={toggleDeleteModel}>Close</Button>
               </ModalFooter>
           </Modal>
        </>
    );
};

export default AdminDashboardTableBody;